import { jsPDF } from 'jspdf';

$(document).ready(function () {
    if (!$('.PipeNotchingCalculatorPage').length) return;

    const RAD = Math.PI / 180;
    const RAD360 = 2 * Math.PI;
    const RAD180 = Math.PI;

    setTimeout(() => {
        hpaPncupdateGraphicText();
    }, 0);

    $('#half-template').on('change', function () {
        hpaPncupdateGraphicText();
    });

    $('#plot-points-checkbox').on('change', function () {
        hpaPncupdateGraphicText();
    });

    $('#plot-increments-metric, #plot-increments-imperial').on('change', function () {
        hpaPncupdateGraphicText();
    });

    $('#btnMetric').click(function () {
        $('#metric-parent-diameter').show();
        $('#imperial-parent-diameter').hide();
        $('#metric-cut-diameter').show();
        $('#imperial-cut-diameter').hide();
        $('#metric-wall-thickness').show();
        $('#imperial-wall-thickness').hide();
        $('#plot-increments-metric').show();
        $('#plot-increments-imperial').hide();

        $('#btnMetric').addClass('active');
        $('#btnImperial').removeClass('active');
    });

    $('#btnImperial').click(function () {
        $('#metric-parent-diameter').hide();
        $('#imperial-parent-diameter').show();
        $('#metric-cut-diameter').hide();
        $('#imperial-cut-diameter').show();
        $('#metric-wall-thickness').hide();
        $('#imperial-wall-thickness').show();
        $('#plot-increments-metric').hide();
        $('#plot-increments-imperial').show();

        $('#btnImperial').addClass('active');
        $('#btnMetric').removeClass('active');
    });

    $('#btnMetric, #btnImperial').click(function () {
        hpaPncupdateGraphicText();
    });

    const syncInputs = (rangeSelector, numberSelector) => {
        $(numberSelector).on('input', function () {
            let value = $(this).val().replace(',', '.');
            if (!isNaN(value) && value !== '') {
                $(rangeSelector).val(value);
            }
            hpaPncupdateGraphicText();
        });

        $(rangeSelector).on('input', function () {
            let value = $(this).val();
            if (!isNaN(value) && value !== '') {
                $(numberSelector).val(value);
            }
            hpaPncupdateGraphicText();
        });
    };

    syncInputs('#parent-diameter', '#parent-diameter-text');
    syncInputs('#cut-diameter', '#cut-diameter-text');
    syncInputs('#wall-thickness', '#wall-thickness-text');
    syncInputs('#wall-thick-imperial-rng', '#wall-thick-imperial-txt');
    syncInputs('#cut-angle', '#cut-angle-text');

    $('#parent-diameter-text, #cut-diameter-text').on('keypress', function (event) {
        const charCode = event.which ? event.which : event.keyCode;
        const charStr = String.fromCharCode(charCode);

        if (!charStr.match(/[0-9.,]/)) {
            event.preventDefault();
        }
    });

    $('#cut-angle-text').on('input', function () {
        let value = $(this).val();
        value = value.replace(/[^0-9]/g, '');
        $(this).val(value);
    });

    $('input[type="text"]').on('input', function () {
        let isDecimal = $(this).attr('step') && $(this).attr('step').includes('.');
        let id = $(this).attr('id');
        let value = $(this).val();

        if (isDecimal && id !== "cut-angle-text") {
            value = value.replace(/[^0-9.]/g, '');
            value = value.replace(/^(\d*\.?)|\./g, '$1');
        } else {
            value = value.replace(/[^0-9]/g, '');
        }

        $(this).val(value);
    });

    $('#plot-increments-metric, #plot-increments-imperial').on('change', function() {
        hpaPncupdateGraphicText();
    });

    $('input, select, range').on('input change', function () {
        hpaPncupdateGraphicText();
    });

    $('input, select').on('change input', function () {
        const value = $(this).val();
        $(this).attr('data-value', value);
    });

    $('.notching-print').on('click', function (e) {
        e.preventDefault();

        const $this = $(this),
            canvasId = $this.data('canvas-id'),
            pdfFilename = $this.data('pdf-filename'),
            isImperial = $('#btnImperial').hasClass('active');

        let parentDiam, cutDiam, wallThick, angle;

        if (isImperial) {
            const parentInches = $('#parent-diameter-inches').val() || '';
            const parentFrac = $('#parent-diameter-fraction').val() || '';
            const cutInches = $('#cut-diameter-inches').val() || '';
            const cutFrac = $('#cut-diameter-fraction').val() || '';
            if (parentInches && parentFrac) parentDiam = `${parentInches}_${parentFrac}`;
            if (cutInches && cutFrac) cutDiam = `${cutInches}_${cutFrac}`;
            wallThick = $('#wall-thick-imperial-txt').val() || '';
            angle = $('#cut-angle-text').val() || '';
        } else {
            parentDiam = $('#parent-diameter-text').val() || '';
            cutDiam = $('#cut-diameter-text').val() || '';
            wallThick = $('#wall-thickness-text').val() || '';
            angle = $('#cut-angle-text').val() || '';
        }

        const filename = `${pdfFilename}_${parentDiam}-${cutDiam}-${wallThick}-${angle}.pdf`;

        const pdf = new jsPDF({
            orientation: 'p',
            unit: 'px',
            format: 'a4',
        });

        if (canvasId === 'divSet') {
            const fullsetCanvas = $('#divSet').find('canvas');
            if (fullsetCanvas.length) {
                fullsetCanvas.each(function (i, canvas) {
                    if (i > 0) {
                        pdf.addPage('a4', 'p');
                    }
                    pdf.addImage(canvas.toDataURL('image/png', 1.0), 'PNG', 10, 10);
                });
            }
        } else {
            const canvas = $('#' + canvasId)[0];
            if (canvas) {
                const imgData = canvas.toDataURL('image/png', 1.0);
                pdf.addImage(imgData, 'PNG', 10, 10);
            }
        }

        pdf.save(filename);
    });

    // $('#calculate-btn').click(function() {
    //     hpaPnccalculate();
    // });

    function hpaPncupdateGraphicText() {
        const isImperial = $('#btnImperial').hasClass('active');
        let parentDiameter = 0, cutDiameter = 0, wallThickness = 0, angle = 0, isValid = true;

        if (isImperial) {
            parentDiameter = hpaPncConvertFraction('parent-diameter-inches', 'parent-diameter-fraction');
            cutDiameter = hpaPncConvertFraction('cut-diameter-inches', 'cut-diameter-fraction');
            wallThickness = parseFloat($('#wall-thick-imperial-txt').val()) || 0;

            if (parentDiameter < 0.5) {
                $('#parent-diameter-error').text(hpaTranslatedtext.pipeNotchingCalculator.validation.parentDiameterImperialBounds).show(); // Parent tube diameter must be 1/2" or larger
                isValid = false;
            } else {
                $('#parent-diameter-error').hide();
            }

            if (cutDiameter < 0.5) {
                $('#cut-diameter-error').text(hpaTranslatedtext.pipeNotchingCalculator.validation.cutDiameterImperialBounds).show(); // Cut tube diameter must be 1/2" or larger
                isValid = false;
            } else {
                $('#cut-diameter-error').hide();
            }

            if (parentDiameter < cutDiameter) {
                $('#parent-diameter-error').text(hpaTranslatedtext.pipeNotchingCalculator.validation.cutTubeLargerThanParentImperial).show(); // Cut tube is larger than Parent Tube. Adjust Parent Tube Diameter to match Cut Tube Diameter.
                isValid = false;
            } else {
                $('#parent-diameter-error').hide();
            }

            if (wallThickness >= cutDiameter / 3) {
                $('#wall-thickness-error').text(hpaTranslatedtext.pipeNotchingCalculator.validation.wallThicknessImperialRatio).show(); // Wall Thickness must be less than one-third of Cut Tube Diameter.
                isValid = false;
            } else {
                $('#wall-thickness-error').hide();
            }
        } else {
            parentDiameter = parseFloat($('#parent-diameter-text').val()) || 0;
            cutDiameter = parseFloat($('#cut-diameter-text').val()) || 0;
            wallThickness = parseFloat($('#wall-thickness-text').val()) || 0;

            if (parentDiameter < 10 || parentDiameter > 1400) {
                $('#parent-diameter-error').text(hpaTranslatedtext.pipeNotchingCalculator.validation.parentDiameterMetricBounds).show(); // Parent Tube Diameter must be between 10 and 1400.
                isValid = false;
            } else {
                $('#parent-diameter-error').hide();
            }

            if (cutDiameter < 10 || cutDiameter > 650) {
                $('#cut-diameter-error').text(hpaTranslatedtext.pipeNotchingCalculator.validation.cutDiameterMetricBounds).show(); // Cut Tube Diameter must be between 10 and 650.
                isValid = false;
            } else {
                $('#cut-diameter-error').hide();
            }

            if (wallThickness >= cutDiameter / 3) {
                $('#wall-thickness-error').text(hpaTranslatedtext.pipeNotchingCalculator.validation.wallThicknessMetricRatio).show(); // Wall Thickness must be less than one-third of Cut Tube Diameter.
                isValid = false;
            } else {
                $('#wall-thickness-error').hide();
            }

            if (cutDiameter > parentDiameter) {
                $('#cut-diameter-error').text(hpaTranslatedtext.pipeNotchingCalculator.validation.cutTubeLargerThanParentMetric).show(); // Cut Tube Diameter must be equal to or smaller than Parent Tube Diameter.
                isValid = false;
            } else {
                $('#cut-diameter-error').hide();
            }
        }

        angle = parseFloat($('#cut-angle-text').val()) || 0;

        if (angle < 15 || angle > 90) {
            $('#angle-error').text(hpaTranslatedtext.pipeNotchingCalculator.validation.angleBounds).show(); // Angle must be between 15° and 90°
            isValid = false;
        } else {
            $('#angle-error').hide();
        }

        const canvasContext = $('#cnvsPipe')[0];
        const drawingContext = canvasContext.getContext('2d');

        drawingContext.clearRect(canvasContext.width - 180, 0, 180, 100);
        drawingContext.fillStyle = '#000';
        drawingContext.font = '12px Verdana';
        drawingContext.textAlign = 'left';
        drawingContext.textBaseline = 'bottom';
        drawingContext.fillText(hpaTranslatedtext.pipeNotchingCalculator.labels.parentTube + (isImperial ? hpaPncformatFraction(parentDiameter) : parentDiameter.toFixed(2) + 'mm'), canvasContext.width - 160, 20); // Parent Tube: 
        drawingContext.fillText(hpaTranslatedtext.pipeNotchingCalculator.labels.cutTube + (isImperial ? hpaPncformatFraction(cutDiameter) : cutDiameter.toFixed(2) + 'mm'), canvasContext.width - 160, 40); // Cut Tube: 
        drawingContext.fillText(hpaTranslatedtext.pipeNotchingCalculator.labels.wallThick + wallThickness, canvasContext.width - 160, 60); // Wall Thick: 
        drawingContext.fillText(hpaTranslatedtext.pipeNotchingCalculator.labels.angle + angle + '°', canvasContext.width - 160, 80); // Angle: 

        if (parentDiameter > 0 && cutDiameter > 0 && angle > 0) {
            hpaPncDrawTemplate(canvasContext, parentDiameter, cutDiameter, wallThickness, angle);
        }
    }

    function hpaPncConvertFraction(inchesId, fracId, returnAsFraction = false) {
        const inches = parseInt($(`#${inchesId}`).val()) || 0;
        const fracValue = parseInt($(`#${fracId}`).val()) || 0;

        if (returnAsFraction) {
            const gcd = (a, b) => b ? gcd(b, a % b) : a;
            const divisor = gcd(fracValue, 32);
            const fraction = fracValue === 0 ? '' : `${fracValue / divisor}/${32 / divisor}`;
            return `${inches}" ${fraction}`;
        }

        const decimalValue = inches + (fracValue / 32);
        return decimalValue;
    }

    function hpaPncformatFraction(value) {
        const whole = Math.floor(value);
        const fraction = value - whole;

        if (fraction === 0) return `${whole}`;

        const numerator = Math.round(fraction * 32);
        const denominator = 32;
        const gcd = (a, b) => b ? gcd(b, a % b) : a;
        const divisor = gcd(numerator, denominator);

        return numerator === 0 ? `${whole}` : `${whole}~${numerator / divisor}/${denominator / divisor}`;
    }

    function hpaPncDrawTemplate(canvasContext, graphicsObject, userInput, renderOptions, viewSettings) {
        const isImperial = $('#btnImperial').hasClass('active');
        const scale = isImperial ? 96 : 96 / 25.4;

        const angleRadians = (90 - viewSettings) * RAD,
            sineAngle = Math.sin(angleRadians),
            cosineAngle = Math.cos(angleRadians);
        const markPoints = $('#plot-points-checkbox').prop('checked');
        const isHalf = $('#half-template').prop('checked');

        let currentAngle = 0,
            angleIncrement = .01,
            parentRadius = graphicsObject / 2,
            parentRadiusSquared = parentRadius * parentRadius,
            cutRadius = userInput / 2,
            cutInnerRadius = cutRadius - renderOptions;

        const circumference = Math.PI * userInput;
        const endAngle = isHalf ? RAD180 : RAD360;

        let points = [], minX = 1E3, maxX = 0;

        for (let angle = 0; angle < endAngle; angle += angleIncrement) {
            const rotatedAngle = (angle - Math.PI / 2) % RAD360;
            const arcLength = cutRadius * angle;
            const outerX = cutRadius * Math.cos(rotatedAngle);
            const outerY = cutRadius * Math.sin(rotatedAngle);
            let upperPoint = (Math.sqrt(parentRadiusSquared - outerX * outerX) + outerY * sineAngle) / cosineAngle;

            const innerX = cutInnerRadius * Math.cos(rotatedAngle);
            const innerY = cutInnerRadius * Math.sin(rotatedAngle);
            let lowerPoint = (Math.sqrt(parentRadiusSquared - innerX * innerX) + innerY * sineAngle) / cosineAngle;

            const finalX = Math.max(upperPoint, lowerPoint);
            points.push(new hpaPncpoint(finalX * scale, arcLength * scale));

            minX = Math.min(minX, finalX);
            maxX = Math.max(maxX, finalX);
        }

        const hTotal = circumference * scale;
        canvasContext.height = hTotal + 30;
        const lTotal = Math.max(400, (maxX - minX) * scale + 40);
        canvasContext.width = lTotal + 60;

        const drawingContext = canvasContext.getContext('2d');
        drawingContext.clearRect(0, 0, canvasContext.width, canvasContext.height);
        drawingContext.save();
        drawingContext.translate(40, 20);
        const offsetX = (minX < 0 ? Math.abs(minX) : -minX) * scale + 18;

        drawingContext.lineWidth = 0.5;
        drawingContext.beginPath();
        drawingContext.moveTo(points[0]._x + offsetX, points[0]._y);
        for (let i = 1; i < points.length; i++) {
            drawingContext.lineTo(points[i]._x + offsetX, points[i]._y);
        }
        drawingContext.stroke();

        if (isHalf) {
            points = points.filter(hpaPncpoint => hpaPncpoint._y <= (circumference / 2) * scale);

            drawingContext.save();
            drawingContext.globalCompositeOperation = 'destination-over';
            drawingContext.fillStyle = '#fff';
            drawingContext.fillRect(offsetX, hTotal / 2, lTotal, hTotal);
            drawingContext.restore();
        }

        if (markPoints) {
            const increments = isImperial
                ? parseInt($('#plot-increments-imperial').val()) || 1
                : parseInt($('#plot-increments-metric').val()) || 1;

            const incrementValue = isImperial ? increments / 32 : increments;
            const incrementAngle = RAD360 / (circumference / incrementValue);
            let incrementPoints = [];

            for (let angle = 0; angle < (isHalf ? RAD180 : RAD360); angle += incrementAngle) {
                const rotatedAngle = (angle - Math.PI / 2) % RAD360;
                const arcLength = cutRadius * angle;
                const outerX = cutRadius * Math.cos(rotatedAngle);
                const outerY = cutRadius * Math.sin(rotatedAngle);
                let upperPoint = (Math.sqrt(parentRadiusSquared - outerX * outerX) + outerY * sineAngle) / cosineAngle;

                const innerX = cutInnerRadius * Math.cos(rotatedAngle);
                const innerY = cutInnerRadius * Math.sin(rotatedAngle);
                let lowerPoint = (Math.sqrt(parentRadiusSquared - innerX * innerX) + innerY * sineAngle) / cosineAngle;

                const finalX = Math.max(upperPoint, lowerPoint);
                const yPosition = arcLength * scale;

                if (!isHalf || yPosition <= (circumference / 2) * scale) {
                    incrementPoints.push(new hpaPncpoint((finalX - minX) * scale, yPosition));
                }
            }

            drawingContext.font = '12px Verdana';
            drawingContext.textAlign = 'right';
            drawingContext.strokeStyle = 'Darkgreen';
            drawingContext.fillStyle = 'Blue';
            drawingContext.textBaseline = 'middle';

            for (let i = 0; i < incrementPoints.length; i++) {
                const p = incrementPoints[i];
                let formattedValue = isImperial
                    ? hpaPncformatFraction(p._x / scale) // mm
                    : (p._x / scale).toFixed(2) + hpaTranslatedtext.pipeNotchingCalculator.labels.unitMM;

                drawingContext.beginPath();
                drawingContext.moveTo(0, p._y);
                drawingContext.lineTo(p._x + 22, p._y);
                drawingContext.stroke();
                drawingContext.fillText(formattedValue, -4, p._y);
            }
        }

        drawingContext.strokeStyle = 'Silver';
        drawingContext.strokeRect(0, 0, lTotal, hTotal);

        drawingContext.fillStyle = '#000';
        drawingContext.font = '12px Verdana';
        drawingContext.textAlign = 'left';
        drawingContext.textBaseline = 'bottom';

        const textX = isImperial ? canvasContext.width - 160 - 30 : canvasContext.width - 160 - 60;
        const textYStart = 20;

        drawingContext.fillText(hpaTranslatedtext.pipeNotchingCalculator.labels.parentTube + (isImperial ? hpaPncConvertFraction('parent-diameter-inches', 'parent-diameter-fraction', true) : graphicsObject.toFixed(2) + hpaTranslatedtext.pipeNotchingCalculator.labels.unitMM), textX, textYStart); // Parent Tube: 
        drawingContext.fillText(hpaTranslatedtext.pipeNotchingCalculator.labels.cutTube + (isImperial ? hpaPncConvertFraction('cut-diameter-inches', 'cut-diameter-fraction', true) : userInput.toFixed(2) + hpaTranslatedtext.pipeNotchingCalculator.labels.unitMM), textX, textYStart + 20); // Cut Tube: 
        drawingContext.fillText(hpaTranslatedtext.pipeNotchingCalculator.labels.wallThick + renderOptions.toFixed(2) + (isImperial ? '"' : hpaTranslatedtext.pipeNotchingCalculator.labels.unitMM), textX, textYStart + 40); // Wall Thick: 
        drawingContext.fillText(hpaTranslatedtext.pipeNotchingCalculator.labels.angle + viewSettings.toFixed(1) + hpaTranslatedtext.pipeNotchingCalculator.labels.unitDegree, textX, textYStart + 60); // Angle: 

        drawingContext.restore();
    }

    function hpaPncpoint(x, y) {
        this._x = x;
        this._y = y;
    }
});



// WEBPACK FOOTER //
// ./js/modules/pipeNotchingCalculator.js